import { ObserverService, FormService, DavisAlertService } from "@DavisDigital/davisdigitalfrontend.module";

class SupportTicketModalController {
    
    private close: Function; //injected from modal-service
    
    public submitting: boolean = false;
    
    public form$ = {
        firstName: '',
        lastName: '',
        email: '',
        schoolOrDistrict: '',
        phone: '',
        problemDescription: '',
        errors: {}
    };
    
	// @ngInject
	constructor(
		private formService      : FormService,
		private davisAlertService: DavisAlertService
	){}
	
	public $onInit = () => {
	    
	};
	
	public submitSupportTicket = () => {
	    if ( !this.submitting ) {
    	    try {
    	        if ( this.formValid() ) {
    	            this.submitting = true;
        	        this.formService.submitForm(
        	            'supportTicket',
        	            { 
            	            name: `${this.form$.firstName} ${this.form$.lastName}`,
                	        emailAddress: this.form$.email,
                	        schoolOrDistrict: this.form$.schoolOrDistrict,
                	        phoneNumber: this.form$.phone,
                	        description: this.form$.problemDescription
        	            }
        	        ).then( ( response ) => {
            			if ( response ) {
            			    if ( response['successfulActions'] && response['successfulActions'].length ) {
            			        this.davisAlertService.success("Successfully submitted request for support.");
            			        this.close();
            			    } else {
                                this.davisAlertService.error("Could not submit request for support.");
            			    }
            			}
            		}).finally(() => {
            			this.submitting = false;
            		});
    	        }
    	    } catch (e) {
                this.davisAlertService.error("Could not submit request for support.");
    	    }
	    }
	};
	
	private formValid(): boolean {
	    this.form$.errors = {};
	    if (!this.form$.firstName) {;
	        this.form$.errors['firstName'] = 'First name is required';
	    }
	    if (!this.form$.lastName) {
	        this.form$.errors['lastName'] = 'Last name is required';
	    }
	    if (!this.form$.email) {
	        this.form$.errors['email'] = 'Email is required';
	    }
	    if (!this.form$.schoolOrDistrict) {
	        this.form$.errors['schoolOrDistrict'] = 'School/District is required';
	    }
	    if (!this.form$.phone) {
	        this.form$.errors['phone'] = 'Phone Number is required';
	    }
	    if (!this.form$.problemDescription) {
	        this.form$.errors['problemDescription'] = 'Problem/Description is required';
	    }
	    
	    return !Object.keys(this.form$.errors).length;
	}
	
	public onCloseModal = () =>{
		this.close();
	}
}

class SupportTicketModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
		close:'='
	};

	public controller = SupportTicketModalController;
	public controllerAs = 'supportModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/support-ticket-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { SupportTicketModal };